import Base from './base'

//国际化语言
class Lang extends Base {
  //获取某语言数据
  static async getLangTexts(lang) {
    let langTexts = $tool.ss.getItem(lang)
    if (langTexts) {
      return langTexts
    }
    let res = await window.$httpUtil.instance.get('expense/common/langGlobal.json', {lang})
    if (res.code == 0) {
      return this.turnLangToMap(res.data)
    } else {
      console.error('无法加载国际化数据')
    }
  }

  static turnLangToMap(langData) {
    let rs = {}
    if (langData.lang && langData.langTexts) {
      langData.langTexts.forEach(lt => {
        var key = lt.msgKey
        if (lt.msgColumn) {
          if (rs[key]) {
            rs[key][lt.msgColumn] = lt.text
          } else {
            var newObj = {}
            newObj[lt.msgColumn] = lt.text
            rs[key] = newObj
          }
        } else {
          rs[key] = lt.text
        }
      })
      $tool.ss.setItem(langData.lang, rs)
    }
    return rs
  }

  //加载全局国际化数据
  static loadGlobalLang() {
    return window.$httpUtil.instance.get('expense/common/allLangGlobal.json')
  }

  //加载当前页面国际化数据
  static loadCurPageLang(pageKey) {
    return window.$httpUtil.instance.get('expense/common/pageKeyLangGlobal.json', {pageKey})
  }

  //保存国际化数据
  static saveLangTxts(data) {
    return window.$httpUtil.instance.post('expense/common/saveLangTxt.json', data)
  }
}

export default Lang
